import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import Meta from 'vue-meta'
import Helpers from './utils/helpers'

Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(Helpers)
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
